import { Image } from '@chakra-ui/react';
import * as React from 'react';
import styled from 'styled-components';

type Props = {
    // buttonText: string,
}
export const DistributionPeriodEndedImage: React.FC<Props> = (props) => {
  const imageWrapperStyle: React.CSSProperties = {
    paddingTop: '90px',
    // marginLeft:`30px`,
  };
  return (
    <div id="imagewrapper" style={imageWrapperStyle}>
        <Image
          src='https://nfttopshot-template-shimamura-develop.onrender.com/template-images/waiting2.png'
          display={'unset'}
        />
    </div>
  );
};